import React from 'react';
import { IconLock, IconShieldLock } from '@tabler/icons-react';

export const UnauthorizedTableState = ({ tabName }) => {
    const brandColor = "#7a3a5e";

    return (
        <div
            className="d-flex align-items-center justify-content-center border border-dashed"
            style={{
                minHeight: '150px',
                width: '100%',
                background: 'linear-gradient(135deg, #f8fafc 0%, #f1f1f6 100%)',
                borderRadius: '12px',
                borderColor: '#e2e8f0',
                padding: '20px'
            }}
        >
            <div className="d-flex align-items-center gap-4 text-start" style={{ maxWidth: '500px' }}>

                {/* Compact Lock Icon */}
                <div
                    className="rounded-circle d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                    style={{
                        width: '54px',
                        height: '54px',
                        backgroundColor: '#fff',
                        border: '1px solid #e2e8f0',
                    }}
                >
                    <IconLock size={24} color={brandColor} stroke={2} />
                </div>

                {/* Content Block */}
                <div>
                    <div className="d-flex align-items-center gap-2 mb-1">
                        <h6 className="fw-bold m-0" style={{ color: '#1e293b', fontSize: '15px' }}>
                            Access Restricted
                        </h6>
                        <span
                            className="badge border-0"
                            style={{
                                backgroundColor: 'rgba(122, 58, 94, 0.08)',
                                color: brandColor,
                                fontSize: '10px',
                                padding: '4px 8px'
                            }}
                        >
                            {tabName}
                        </span>
                    </div>

                    <p
                        className="mb-0 text-muted"
                        style={{ fontSize: '13px', lineHeight: '1.4' }}
                    >
                        You don't have permission to view this table. <br />
                        Please contact your <span className="fw-semibold" style={{ color: brandColor }}>Administrator</span>.
                    </p>
                </div>
            </div>
        </div>
    );
};